import { backoffRetrier } from "../utils";
/**
 * Represents an abstract HTTP API.
 */
export default class HttpApi {
    #apiUrl;
    /**
     * Retry options for API requests.
     */
    #retryOptions;
    constructor(apiUrl, retryOptions = {
        retries: 5,
        backoffStepMs: 1000,
    }) {
        this.#apiUrl = apiUrl;
        this.#retryOptions = retryOptions;
    }
    /**
     * Makes an HTTP request with retry logic.
     * @param requestFn Function that returns a Promise of the HTTP response.
     * @returns The HTTP response.
     * @throws Error if the request fails after all retries.
     */
    async #requestWithRetry(requestFn) {
        return backoffRetrier(this.#retryOptions.retries, this.#retryOptions.backoffStepMs)(async () => {
            const response = await requestFn();
            if (!response.ok) {
                throw new Error(`Request failed: ${await response.text()}`);
            }
            return response;
        });
    }
    /**
     * Factory function for running GET requests.
     * @param endpoint API endpoint.
     * @param requestInit Additional data passed to request.
     * @returns API response.
     */
    async getRequest(endpoint, requestInit) {
        return this.#requestWithRetry(async () => fetch(new URL(endpoint, this.#apiUrl), {
            credentials: "include",
            ...requestInit,
        }));
    }
    /**
     * Factory function for running POST requests.
     * @param endpoint API endpoint,
     * @param body Data passed to POST request.
     * @param requestInit Additional data passed to request.
     * @returns API response.
     */
    async postRequest(endpoint, body, requestInit) {
        return this.#requestWithRetry(async () => fetch(new URL(endpoint, this.#apiUrl), {
            method: "POST",
            body: JSON.stringify(body),
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            ...requestInit,
        }));
    }
}
//# sourceMappingURL=HttpApi.js.map